import { useContext } from "react";
import PiPContext from "../PiPContext";

export function usePiPWindow() {
    const context = useContext(PiPContext);

    if (context === undefined) {
        throw new Error("usePiPWindow must be used within a PiPContext");
    }

    return context;
}
